// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.data-check-flag,\n.el-table th.data-check-flag {\n  width: 6em;\n}\n.el-table i.el-icon-success {\n  font-size: 1.7em;\n  color: #3cb371;\n}\n.el-table i.el-icon-error {\n  font-size: 1.7em;\n  color: #dc143c;\n}", ""]);
// Exports
module.exports = exports;
